module.exports = __webpack_public_path__ + "static/img/0.cb79cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw/0.png
// module id = EHvb
// module chunks = 1